
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner/google/[path]",
      function () {
        return require("private-next-pages/partner/google/[path].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner/google/[path]"])
      });
    }
  